import "react-loading-skeleton/dist/skeleton.css";
import "react-notifications/lib/notifications.css";

import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { NotificationContainer } from "react-notifications";
import { IAdminData, IUserAccount } from "./common/interfaces/user.interface";
import BulkTransactionsModal from "./components/BulkTransactionsModal/BulkTransactionsModal";
import WalletModal from "./components/WalletModal/WalletModal";
import { WalletWrapper } from "./components/WalletWrapper/WalletWrapper";
import { UserContext } from "./contexts/userContext";
import Routes from "./Routes";
import { INotification } from "./common/interfaces/notifications.interface";
import { socket } from "./solana/common/helpers/common.helpers";
import GatewayProvider from "./pages/UserVerification/Gateway";
import ScrollToTopButton from "./components/ScrollToTopButton/ScrollToTopButton";

export const App: React.FC = () => {
  const [user, setUser] = useState<IUserAccount | undefined>();
  const [notifications, setNotifications] = useState<INotification[]>([]);
  const [isNotificationsModalVisible, toggleNotificationsModal] =
    useState<boolean>(false);
  const [isWhitelisted, toggleIsWhitelisted] = useState(false);
  const GA_MEASUREMENT_ID = "G-LSETPC3FYH";
  const [isXnft, setIsXnft] = useState(false);
  const [adminData, setAdminData] = useState<IAdminData>();
  const [loading, toggleLoading] = useState(false);

  ReactGA.initialize(GA_MEASUREMENT_ID);
  ReactGA.send("pageview");

  useEffect(() => {
    const notificationEvent = "newNotification";
    socket.on(notificationEvent, (data: string) => {
      const notificationDto: INotification = JSON.parse(data);
      setNotifications((prevValue) => [notificationDto, ...prevValue]);
    });

    return () => {
      socket.off(notificationEvent);
    };
  }, []);

  const updateUser = (user: IUserAccount | undefined) => {
    setUser(user);
  };

  return (
    <WalletWrapper>
      <GatewayProvider>
        <UserContext.Provider
          value={{
            user,
            isXnft,
            setIsXnft,
            updateUser,
            notifications,
            setNotifications,
            isNotificationsModalVisible,
            toggleNotificationsModal,
            isWhitelisted,
            toggleIsWhitelisted,
            adminData,
            setAdminData,
          }}
        >
          <Routes />
          <NotificationContainer />
          <BulkTransactionsModal />
          <WalletModal />
          <ScrollToTopButton />
        </UserContext.Provider>
      </GatewayProvider>
    </WalletWrapper>
  );
};
